import { Component, ViewEncapsulation } from '@angular/core';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';

@Component({
    selector: 'medpt-toast',
    templateUrl: './medpt-toast.component.html',
    styleUrls: ['./medpt-toast.component.scss'],
    encapsulation: ViewEncapsulation.None,
    preserveWhitespaces: false,
    standalone: false
})
export class MedptToastComponent extends Toast {

  // constructor is only necessary when not using AoT
  constructor(protected override toastrService: ToastrService, public override toastPackage: ToastPackage) {
    super(toastrService, toastPackage);
  }

  removeToast(event: any) {
    event.stopPropagation();
    this.toastPackage.triggerAction(this.toastPackage.toastRef.componentInstance);
    this.remove();
    return false;
  }
}
